import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject, map } from 'rxjs';
import { VaelsysWebrtcLibService } from 'vaelsys-webrtc-lib';
import { GlobalVariablesService } from '../global-variables.service';

@Injectable({
  providedIn: 'root'
})
export class VaelsysWebrtcService {

  serviceInit = false;
  updateStatusService$ = new Subject<{status: boolean, user?: string}>();
  user: string;
  constructor(
    private vaelsysWebRtcService: VaelsysWebrtcLibService,
    public gvs: GlobalVariablesService
  ) {
      this.updateStatusService$.subscribe(async data => {
        this.user = data.user;
        if(data.status){
          await this.init();
        }else{
          await this.dispose();
        }
      })
   }

  async init() : Promise<boolean> {
    return await this.vaelsysWebRtcService.init(this.user)
    .then((value) => {
      if(value){
        this.serviceInit = true;
      }
      return value;
    })
    .catch((err) => {
      return false;
    });
  }

  async dispose() : Promise<boolean> {
    return await this.vaelsysWebRtcService.dispose()
    .then((value) => {
      return value;
    })
    .catch((err) =>{
      return false;
    });
  }

  async check(deal_id: string, s_ins: number, s_cam: number, device_id: string, validation_code: string) : Promise<number> {
    return await this.vaelsysWebRtcService.check(deal_id, s_ins, s_cam, device_id, validation_code)
    .then((value) => {
      return value;
    })
    .catch((err) => {
      return 500;
    });
  }

  subscribeConnectionState() {
    return this.vaelsysWebRtcService.connectionState.pipe(
      map(value => value)
    );
  }

  async _checkStreamConnected() : Promise<boolean> {
    // We need to wait on the behaviour subject to check if the state changes
    return await this._checkCondition(() => this.vaelsysWebRtcService.connectionState.getValue() == 'streamconnected', 30);
  }

  async _checkVideoPlaying() : Promise<boolean> {
    return await this._checkCondition(() => this.vaelsysWebRtcService.connectionState.getValue() == 'streaming', 30);
  }

  async _checkCondition(fn: () => boolean, timeoutSecs: number) : Promise<boolean> {
    let ret : boolean = false;
    const timerMsecs = 100;
    ret = await new Promise((resolve, reject) => {
      let mSecs = 0;
      (function waitFor() {
        if (fn()) {
          return resolve(true);
        } else if (mSecs < timeoutSecs*1000) {
          mSecs += timerMsecs;
          setTimeout(waitFor, timerMsecs);
        } else {
          console.error('***** Timeout checking for condition *****');
          return resolve(false);
        }
      })();
    });
  
    return ret;
  }
}
